export default {
  notifications: {},
  organisation: {},
  loggedInUser: {
    currency: `USD`,
    isCoach: true,
    isPlayer: false,
  },
  stripe: {
    discount: {
      exists: false,
    },
  },
  billing: {},
  signup: {},
  trainingGround: {
    popularSearches: {},
    contentFeed: {
      Recommended: [],
      Favourites: {},
      Latest: [],
      loading: true,
    },
  },
  contentList: {
    data: [],
  },
  content: {},
  session: {
    drills: [],
    loading: true,
  },
  diagram: {},
  comments: {
    count: 0,
    data: [],
  },
  metadata: {},
  favourited: false,
  liked: false,
  reported: false,
  doIFollow: [],
  access: {},
  shareCounts: {
    facebook: 0,
    twitter: 0,
    loaded: false,
  },
  folders: {
    data: [],
    loading: true,
    idTree: {},
    availableAccessors: [],
  },
  images: {
    data: [],
    loading: true,
  },
  licences: {
    information: {},
    allocated: [],
  },
  search: {
    result_count: [],
    results: [],
    links: [],
    loading: true,
    trendingSearches: {
      results: [],
      loading: true,
    },
    secondaryFilters: {},
  },
};



// WEBPACK FOOTER //
// ./library/app/reducers/initialState.js